import { render, staticRenderFns } from "./BottomNavigationBar.vue?vue&type=template&id=c6f5d8d6&scoped=true&"
import script from "./BottomNavigationBar.vue?vue&type=script&lang=js&"
export * from "./BottomNavigationBar.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavigationBar.vue?vue&type=style&index=0&id=c6f5d8d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f5d8d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBottomNavigation,VBtn,VIcon,VImg})
